import DomainMapping from './Container';

export default DomainMapping;